<template>
  <fragment>
    <div class="col-md-9" v-show="statusManutencao" style="margin-left: auto; margin-right: auto">
      <div class="col-12">
        <b-alert show variant="info">
          Para baixar em PDF sua Carta Declaração de Filiação
          <b-button @click="!loading ? abrirChamado() : ''" variant="info" :class="{ disabled: loading }">
            <span class="spinner-grow spinner-grow-sm pr-2" role="status" aria-hidden="true" v-show="loading"></span>
            <span v-if="loading">Baixando...</span>
            <span v-else>Clique aqui</span>
          </b-button>

          <p class="mb-4"></p>
        </b-alert>

        <div class="row">
          <div class="col-md-4">
            <Botao title="Voltar" @click="$router.push({ name: 'Dashboard' })"
              nameClass="btn btn-outline-secondary btn-lg btn-block">VOLTAR</Botao>
          </div>
          <div class="col-md-4 col-lg-3">
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import Botao from "@/components/botoes/Botao";
export default {
  name: "CartaDeclaracao",
  components: { Botao },
  data() {
    return {
      file: null,
      produto: {
        nome: "Carta Declaração de Filiação",
        id: "cartaDeclaracao",
      },
      loading: false,
      statusManutencao: true,
      closeModal: false,
      breadcrumb: [
        {
          nome: "Carta Declaração de Filiação",
          id: "cartaDeclaracao",
        },
      ],
    };
  },
  methods: {
    abrirChamado() {
      this.loading = true;
      if (!sessionStorage.ip) {
        fetch(process.env.VUE_APP_IP_API + "?format=json")
          .then((x) => x.json())
          .then(({ ip }) => {
            sessionStorage.ip = ip;
          });
      }

      let d = new Date();
      let date = new Date(d.valueOf() - d.getTimezoneOffset() * 60000);

      const dadosDeclaracao = {
        dtVersao: date,
        dtAceite: date,
        ipOrigem: sessionStorage.ip,
        browserData: navigator.appVersion,
      };

      this.$http
        .post("/api/Declaracao/SolicitarDeclaracao", dadosDeclaracao)
        .then((response) => {
          this.loading = false;

          const binaryData = atob(response.data.fileContents);

          // Crie um ArrayBuffer a partir dos dados binários
          const arrayBuffer = new ArrayBuffer(binaryData.length);
          const uint8Array = new Uint8Array(arrayBuffer);

          // Preencha o ArrayBuffer com os dados binários
          for (let i = 0; i < binaryData.length; i++) {
            uint8Array[i] = binaryData.charCodeAt(i);
          }

          // Crie um Blob a partir do ArrayBuffer com o tipo de conteúdo correto
          const blob = new Blob([arrayBuffer], { type: 'application/pdf' });

          // Crie um URL temporário para o Blob
          const url = URL.createObjectURL(blob);

          // Crie um link de download
          const downloadLink = document.createElement('a');
          downloadLink.href = url;
          downloadLink.download = response.data.fileDownloadName; // Nome do arquivo de download

          // Adicione o link de download à página
          document.body.appendChild(downloadLink);

          downloadLink.click();






        })
        .catch(() => {
          this.loading = false;
          this.$toast.open({
            message: "Erro ao solicitar declaração, tente novamente.",
            type: "error",
          });
        });
    },
    base64ToArrayBuffer(base64) {
      const binaryString = window.atob(base64);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      return bytes.buffer;
    }
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
  },
};
</script>
